// src/components/Dashboard/TemplateCard.js
import React from 'react';
import { Card, CardContent, Typography, CardActions, Button, Box } from '@mui/material';

const TemplateCard = ({ template, onEdit, onDelete }) => {
  return (
    <Card
      sx={{
        width: '100%',
        mb: 2,
        height: 250, // Adjust the height as desired
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: '#1E1E1E', // Dark/black background
        color: '#FFFFFF',           // White text
        border: '1px solid #333',
        borderRadius: 8,
        boxShadow: '0 0 10px rgba(0, 255, 0, 0.2)', // Subtle glow
        transition: 'all 0.3s ease',
        '&:hover': {
          borderColor: '#00ff00',
          boxShadow: '0 0 15px rgba(0, 255, 0, 0.3)',
        },
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Box sx={{ textAlign: 'center', mb: 1 }}>
          <Typography
            variant="subtitle2"
            component="span"
            sx={{ fontWeight: 'bold', color: '#FFFFFF' }}
          >
            Name:
          </Typography>
          <Typography
            variant="h6"
            component="span"
            sx={{ ml: 1, color: '#FFFFFF' }}
          >
            {template.name}
          </Typography>
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            variant="subtitle2"
            component="span"
            sx={{ fontWeight: 'bold', color: '#FFFFFF' }}
          >
            Subject:
          </Typography>
          <Typography
            variant="body2"
            component="span"
            sx={{ ml: 1, color: '#FFFFFF' }}
          >
            {template.subject}
          </Typography>
        </Box>
      </CardContent>

      <CardActions sx={{ justifyContent: 'center' }}>
        {onEdit && (
          <Button
            variant="outlined"
            sx={{
              color: '#00ff00',
              borderColor: '#00ff00',
              '&:hover': {
                backgroundColor: '#00ff00',
                color: '#1E1E1E',
              },
            }}
            onClick={() => onEdit(template)}
          >
            Edit
          </Button>
        )}
        {onDelete && (
          <Button
            variant="outlined"
            sx={{
              ml: 1,
              color: '#ff1744',
              borderColor: '#ff1744',
              '&:hover': {
                backgroundColor: '#ff1744',
                color: '#1E1E1E',
              },
            }}
            onClick={() => onDelete(template.id)}
          >
            Delete
          </Button>
        )}
      </CardActions>
    </Card>
  );
};

export default TemplateCard;
